import { render, staticRenderFns } from "./CardRoute.vue?vue&type=template&id=62f5489e&scoped=true&"
import script from "./CardRoute.vue?vue&type=script&lang=js&"
export * from "./CardRoute.vue?vue&type=script&lang=js&"
import style0 from "./CardRoute.vue?vue&type=style&index=0&id=62f5489e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f5489e",
  null
  
)

export default component.exports